import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/accounting/`;

const exportYearStartUnshippedBeamPaymentsExcel = async () => {
  const response = await axios.get(`${API_URL}year-start-unshipped-beam/excel`, {
    responseType: 'blob',
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'accounting_year_start_unshipped_beam_2026.xlsx');
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export default {
  exportYearStartUnshippedBeamPaymentsExcel,
};

